// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MyFollowing_wrapper__e4B-C {
    width: 100%;
    padding-top: 80px;
    background-color: #121212;
    min-height: 100vh;
  }
  
  .MyFollowing_container__iAryS {
    max-width: 1200px;
    margin: 0 auto;
    padding: 40px;
    background-color: #1a1a1a;
    border-radius: 20px;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  }
  
  .MyFollowing_header__MY9ug {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 50px;
  }
  
  .MyFollowing_profileImage__Z5lrn {
    width: 120px;
    height: 120px;
    border-radius: 50%;
    background-color: #ff0000;
    margin-bottom: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .MyFollowing_profileIcon__cW4np {
    width: 60px;
    height: 60px;
    color: white;
  }
  
  .MyFollowing_name__6XVh2 {
    color: #ffffff;
    font-size: 32px;
    margin-bottom: 30px;
    text-transform: uppercase;
    letter-spacing: 3px;
    font-weight: bold;
  }
  
  .MyFollowing_searchContainer__Q5h52 {
    width: 100%;
    max-width: 600px;
    position: relative;
    margin-bottom: 40px;
  }
  
  .MyFollowing_searchInput__XGaSx {
    width: 100%;
    padding: 16px 50px 16px 24px;
    border: 2px solid #333;
    border-radius: 50px;
    font-size: 16px;
    outline: none;
    transition: all 0.3s ease;
    background-color: #2a2a2a;
    color: #ffffff;
  }
  
  .MyFollowing_searchInput__XGaSx:focus {
    border-color: #ff0000;
    box-shadow: 0 0 0 4px rgba(255, 0, 0, 0.2);
  }
  
  .MyFollowing_searchInput__XGaSx::placeholder {
    color: #888;
  }
  
  .MyFollowing_searchIcon__fM-Ox {
    position: absolute;
    right: 20px;
    top: 50%;
    transform: translateY(-50%);
    color: #888;
    font-size: 20px;
  }
  
  .MyFollowing_authorGrid__cirDO {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
    margin-bottom: 30px;
  }
  
  .MyFollowing_authorCard__C00Ao {
    display: flex;
    align-items: center;
    padding: 20px;
    background-color: #2a2a2a;
    border-radius: 15px;
    transition: all 0.3s ease;
    border: 1px solid #333;
  }
  
  .MyFollowing_authorCard__C00Ao:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 12px rgba(255, 0, 0, 0.1);
    border-color: #ff0000;
    background-color: #333;
  }
  
  .MyFollowing_authorInfo__AOQRu {
    display: flex;
    align-items: center;
    flex-grow: 1;
    cursor: pointer;
    text-decoration: none;
    color: inherit;
  }
  
  .MyFollowing_authorImage__lH2gS {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    background-color: #e31414;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.5rem;
    font-weight: bold;
    margin-right: 10px;
  }
  
  .MyFollowing_emptyState__RsVGx {
    text-align: center;
    padding: 2rem;
    color: #666;
    font-size: 1.1rem;
  }
  
  .MyFollowing_authorInfo__AOQRu:hover .MyFollowing_authorImage__lH2gS {
    transform: scale(1.05);
    border-color: #ff0000;
  }
  
  .MyFollowing_authorName__qCJCS {
    font-size: 18px;
    color: #ffffff;
    font-weight: 500;
    transition: color 0.3s ease;
  }
  
  .MyFollowing_authorInfo__AOQRu:hover .MyFollowing_authorName__qCJCS {
    color: #ff0000;
  }
  
  .MyFollowing_unfollowButton__XTEt5 {
    padding: 10px 24px;
    border: none;
    border-radius: 25px;
    background-color: #ff0000;
    color: white;
    cursor: pointer;
    transition: all 0.3s ease;
    font-weight: 500;
    font-size: 14px;
  }
  
  .MyFollowing_unfollowButton__XTEt5:hover {
    background-color: #cc0000;
    transform: scale(1.05);
  }
  
  .MyFollowing_seeAllButton__x8iD2, .MyFollowing_seeMoreButton__cz2L8 {
    display: block;
    width: fit-content;
    margin: 30px auto 0;
    padding: 12px 30px;
    background-color: #ff0000;
    color: white;
    border: none;
    border-radius: 25px;
    font-size: 16px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.3s ease;
    animation: MyFollowing_pulse__nbr\\+\\+ 2s infinite;
  }
  
  .MyFollowing_seeAllButton__x8iD2:hover, .MyFollowing_seeMoreButton__cz2L8:hover {
    background-color: #cc0000;
    transform: scale(1.05);
    animation: none;
  }
  
  @keyframes MyFollowing_pulse__nbr\\+\\+ {
    0% {
      transform: scale(1);
      box-shadow: 0 0 0 0 rgba(255, 0, 0, 0.4);
    }
    70% {
      transform: scale(1.05);
      box-shadow: 0 0 0 10px rgba(255, 0, 0, 0);
    }
    100% {
      transform: scale(1);
      box-shadow: 0 0 0 0 rgba(255, 0, 0, 0);
    }
  }
  
  .MyFollowing_loadingContainer__GdjgN {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 200px;
    color: #ffffff;
    font-size: 18px;
  }
  
  @media (max-width: 768px) {
    .MyFollowing_authorGrid__cirDO {
      grid-template-columns: 1fr;
    }
    
    .MyFollowing_container__iAryS {
      padding: 20px;
    }
    
    .MyFollowing_searchContainer__Q5h52 {
      max-width: 100%;
    }
    .MyFollowing_authorName__qCJCS{
        font-size: 16px;
    }
  }

  .MyFollowing_searchContainer__Q5h52 {
    width: 100%;
    max-width: 600px;
    position: relative;
    margin-bottom: 40px;
    display: flex;
    align-items: center;
  }
  
  .MyFollowing_searchInput__XGaSx {
    width: 100%;
    padding: 16px 50px 16px 24px;
    border: 2px solid #333;
    border-radius: 50px;
    font-size: 16px;
    outline: none;
    transition: all 0.3s ease;
    background-color: #2a2a2a;
    color: #ffffff;
  }
  
  .MyFollowing_searchIconWrapper__JQvYz {
    position: absolute;
    right: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    pointer-events: none;
  }
  
  .MyFollowing_searchIcon__fM-Ox {
    color: #888;
    width: 20px;
    height: 20px;
  }
  .MyFollowing_pagination__w2Cz8 {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 20px;
    gap: 10px;
  }
  
  .MyFollowing_paginationButton__5CqeD {
    padding: 6px 12px;
    background-color: #ff0000;
    color: #fff;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    transition: background-color 0.3s ease;
  }
  
  .MyFollowing_paginationButton__5CqeD:disabled {
    background-color: #444;
    cursor: not-allowed;
  }
  
  .MyFollowing_paginationInfo__a43i- {
    color: #fff;
    font-size: 1rem;
  }
  `, "",{"version":3,"sources":["webpack://./src/pages/followers/CSS/MyFollowing.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,iBAAiB;IACjB,yBAAyB;IACzB,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,cAAc;IACd,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,yCAAyC;EAC3C;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,cAAc;IACd,eAAe;IACf,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,4BAA4B;IAC5B,sBAAsB;IACtB,mBAAmB;IACnB,eAAe;IACf,aAAa;IACb,yBAAyB;IACzB,yBAAyB;IACzB,cAAc;EAChB;;EAEA;IACE,qBAAqB;IACrB,0CAA0C;EAC5C;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,2BAA2B;IAC3B,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,yBAAyB;IACzB,sBAAsB;EACxB;;EAEA;IACE,2BAA2B;IAC3B,2CAA2C;IAC3C,qBAAqB;IACrB,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,qBAAqB;IACrB,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,qBAAqB;EACvB;;EAEA;IACE,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,2BAA2B;EAC7B;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;IACzB,YAAY;IACZ,eAAe;IACf,yBAAyB;IACzB,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,yBAAyB;IACzB,sBAAsB;EACxB;;EAEA;IACE,cAAc;IACd,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,iDAA4B;EAC9B;;EAEA;IACE,yBAAyB;IACzB,sBAAsB;IACtB,eAAe;EACjB;;EAEA;IACE;MACE,mBAAmB;MACnB,wCAAwC;IAC1C;IACA;MACE,sBAAsB;MACtB,yCAAyC;IAC3C;IACA;MACE,mBAAmB;MACnB,sCAAsC;IACxC;EACF;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;IACjB,cAAc;IACd,eAAe;EACjB;;EAEA;IACE;MACE,0BAA0B;IAC5B;;IAEA;MACE,aAAa;IACf;;IAEA;MACE,eAAe;IACjB;IACA;QACI,eAAe;IACnB;EACF;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,4BAA4B;IAC5B,sBAAsB;IACtB,mBAAmB;IACnB,eAAe;IACf,aAAa;IACb,yBAAyB;IACzB,yBAAyB;IACzB,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,oBAAoB;EACtB;;EAEA;IACE,WAAW;IACX,WAAW;IACX,YAAY;EACd;EACA;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,SAAS;EACX;;EAEA;IACE,iBAAiB;IACjB,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,sCAAsC;EACxC;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB","sourcesContent":[".wrapper {\n    width: 100%;\n    padding-top: 80px;\n    background-color: #121212;\n    min-height: 100vh;\n  }\n  \n  .container {\n    max-width: 1200px;\n    margin: 0 auto;\n    padding: 40px;\n    background-color: #1a1a1a;\n    border-radius: 20px;\n    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);\n  }\n  \n  .header {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    margin-bottom: 50px;\n  }\n  \n  .profileImage {\n    width: 120px;\n    height: 120px;\n    border-radius: 50%;\n    background-color: #ff0000;\n    margin-bottom: 24px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n  \n  .profileIcon {\n    width: 60px;\n    height: 60px;\n    color: white;\n  }\n  \n  .name {\n    color: #ffffff;\n    font-size: 32px;\n    margin-bottom: 30px;\n    text-transform: uppercase;\n    letter-spacing: 3px;\n    font-weight: bold;\n  }\n  \n  .searchContainer {\n    width: 100%;\n    max-width: 600px;\n    position: relative;\n    margin-bottom: 40px;\n  }\n  \n  .searchInput {\n    width: 100%;\n    padding: 16px 50px 16px 24px;\n    border: 2px solid #333;\n    border-radius: 50px;\n    font-size: 16px;\n    outline: none;\n    transition: all 0.3s ease;\n    background-color: #2a2a2a;\n    color: #ffffff;\n  }\n  \n  .searchInput:focus {\n    border-color: #ff0000;\n    box-shadow: 0 0 0 4px rgba(255, 0, 0, 0.2);\n  }\n  \n  .searchInput::placeholder {\n    color: #888;\n  }\n  \n  .searchIcon {\n    position: absolute;\n    right: 20px;\n    top: 50%;\n    transform: translateY(-50%);\n    color: #888;\n    font-size: 20px;\n  }\n  \n  .authorGrid {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    gap: 20px;\n    margin-bottom: 30px;\n  }\n  \n  .authorCard {\n    display: flex;\n    align-items: center;\n    padding: 20px;\n    background-color: #2a2a2a;\n    border-radius: 15px;\n    transition: all 0.3s ease;\n    border: 1px solid #333;\n  }\n  \n  .authorCard:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 6px 12px rgba(255, 0, 0, 0.1);\n    border-color: #ff0000;\n    background-color: #333;\n  }\n  \n  .authorInfo {\n    display: flex;\n    align-items: center;\n    flex-grow: 1;\n    cursor: pointer;\n    text-decoration: none;\n    color: inherit;\n  }\n  \n  .authorImage {\n    width: 50px;\n    height: 50px;\n    border-radius: 50%;\n    background-color: #e31414;\n    color: white;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 1.5rem;\n    font-weight: bold;\n    margin-right: 10px;\n  }\n  \n  .emptyState {\n    text-align: center;\n    padding: 2rem;\n    color: #666;\n    font-size: 1.1rem;\n  }\n  \n  .authorInfo:hover .authorImage {\n    transform: scale(1.05);\n    border-color: #ff0000;\n  }\n  \n  .authorName {\n    font-size: 18px;\n    color: #ffffff;\n    font-weight: 500;\n    transition: color 0.3s ease;\n  }\n  \n  .authorInfo:hover .authorName {\n    color: #ff0000;\n  }\n  \n  .unfollowButton {\n    padding: 10px 24px;\n    border: none;\n    border-radius: 25px;\n    background-color: #ff0000;\n    color: white;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    font-weight: 500;\n    font-size: 14px;\n  }\n  \n  .unfollowButton:hover {\n    background-color: #cc0000;\n    transform: scale(1.05);\n  }\n  \n  .seeAllButton, .seeMoreButton {\n    display: block;\n    width: fit-content;\n    margin: 30px auto 0;\n    padding: 12px 30px;\n    background-color: #ff0000;\n    color: white;\n    border: none;\n    border-radius: 25px;\n    font-size: 16px;\n    font-weight: 500;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    animation: pulse 2s infinite;\n  }\n  \n  .seeAllButton:hover, .seeMoreButton:hover {\n    background-color: #cc0000;\n    transform: scale(1.05);\n    animation: none;\n  }\n  \n  @keyframes pulse {\n    0% {\n      transform: scale(1);\n      box-shadow: 0 0 0 0 rgba(255, 0, 0, 0.4);\n    }\n    70% {\n      transform: scale(1.05);\n      box-shadow: 0 0 0 10px rgba(255, 0, 0, 0);\n    }\n    100% {\n      transform: scale(1);\n      box-shadow: 0 0 0 0 rgba(255, 0, 0, 0);\n    }\n  }\n  \n  .loadingContainer {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    min-height: 200px;\n    color: #ffffff;\n    font-size: 18px;\n  }\n  \n  @media (max-width: 768px) {\n    .authorGrid {\n      grid-template-columns: 1fr;\n    }\n    \n    .container {\n      padding: 20px;\n    }\n    \n    .searchContainer {\n      max-width: 100%;\n    }\n    .authorName{\n        font-size: 16px;\n    }\n  }\n\n  .searchContainer {\n    width: 100%;\n    max-width: 600px;\n    position: relative;\n    margin-bottom: 40px;\n    display: flex;\n    align-items: center;\n  }\n  \n  .searchInput {\n    width: 100%;\n    padding: 16px 50px 16px 24px;\n    border: 2px solid #333;\n    border-radius: 50px;\n    font-size: 16px;\n    outline: none;\n    transition: all 0.3s ease;\n    background-color: #2a2a2a;\n    color: #ffffff;\n  }\n  \n  .searchIconWrapper {\n    position: absolute;\n    right: 20px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    pointer-events: none;\n  }\n  \n  .searchIcon {\n    color: #888;\n    width: 20px;\n    height: 20px;\n  }\n  .pagination {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-top: 20px;\n    gap: 10px;\n  }\n  \n  .paginationButton {\n    padding: 6px 12px;\n    background-color: #ff0000;\n    color: #fff;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n    transition: background-color 0.3s ease;\n  }\n  \n  .paginationButton:disabled {\n    background-color: #444;\n    cursor: not-allowed;\n  }\n  \n  .paginationInfo {\n    color: #fff;\n    font-size: 1rem;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `MyFollowing_wrapper__e4B-C`,
	"container": `MyFollowing_container__iAryS`,
	"header": `MyFollowing_header__MY9ug`,
	"profileImage": `MyFollowing_profileImage__Z5lrn`,
	"profileIcon": `MyFollowing_profileIcon__cW4np`,
	"name": `MyFollowing_name__6XVh2`,
	"searchContainer": `MyFollowing_searchContainer__Q5h52`,
	"searchInput": `MyFollowing_searchInput__XGaSx`,
	"searchIcon": `MyFollowing_searchIcon__fM-Ox`,
	"authorGrid": `MyFollowing_authorGrid__cirDO`,
	"authorCard": `MyFollowing_authorCard__C00Ao`,
	"authorInfo": `MyFollowing_authorInfo__AOQRu`,
	"authorImage": `MyFollowing_authorImage__lH2gS`,
	"emptyState": `MyFollowing_emptyState__RsVGx`,
	"authorName": `MyFollowing_authorName__qCJCS`,
	"unfollowButton": `MyFollowing_unfollowButton__XTEt5`,
	"seeAllButton": `MyFollowing_seeAllButton__x8iD2`,
	"seeMoreButton": `MyFollowing_seeMoreButton__cz2L8`,
	"pulse": `MyFollowing_pulse__nbr++`,
	"loadingContainer": `MyFollowing_loadingContainer__GdjgN`,
	"searchIconWrapper": `MyFollowing_searchIconWrapper__JQvYz`,
	"pagination": `MyFollowing_pagination__w2Cz8`,
	"paginationButton": `MyFollowing_paginationButton__5CqeD`,
	"paginationInfo": `MyFollowing_paginationInfo__a43i-`
};
export default ___CSS_LOADER_EXPORT___;
